import {
  FilterMode,
  TenantLlmConfigCreateMutationVariables,
  TenantLlmConfig_OrderBy,
  TenantLlmConfig,
  SortOrder,
  TenantLlmConfig_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const tenantLlmConfigService = {
  createOne: buildCreateOne(
    (tenantLlmConfigCreateVariables: TenantLlmConfigCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.tenantLlmConfigCreate(
          tenantLlmConfigCreateVariables
        );
        return result.tenantLlmConfigCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantLlmConfigOne({ id });
    return result.tenantLlmConfigOne as TenantLlmConfig;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TenantLlmConfig_OrderBy[] | null = null,
    filter: TenantLlmConfig_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantLlmConfig_Filter | undefined;
    if (searchValue !== "") {
      where = {
        model: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantLlmConfigListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ model: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantLlmConfigListWithOffset
    ) as TenantLlmConfig[];
    return { list, orderBy };
  },
};
